import { render, staticRenderFns } from "./Huekoy.vue?vue&type=template&id=2a22f92b&scoped=true&"
import script from "./Huekoy.vue?vue&type=script&lang=js&"
export * from "./Huekoy.vue?vue&type=script&lang=js&"
import style0 from "./Huekoy.vue?vue&type=style&index=0&id=2a22f92b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a22f92b",
  null
  
)

export default component.exports